var OrderContactDataForm = (function ($) {

    OrderContactDataForm = function (options) {
        var that = this;

        // OPTIONS
        that.modal = options['modal'];

        // HANDLERS
        that.onClose = (options['onClose'] || false);

        // CONST
        that.class = {
            order_contact_data_form: 'js-order-contact-data-form',
            input_email: 'js-email',
            input_phone: 'js-phone'
        };

        // DYNAMIC VARS
        that.order_contact_data_modal = null;
        that.order_contact_data = null;

        // INIT
        that.init();
    };

    OrderContactDataForm.prototype.init = function () {
        var that = this;

        that.__showOrderContactDataModal();
    };

    /**
     * @private
     */
    OrderContactDataForm.prototype.__showOrderContactDataModal = function () {
        var that = this,
            is_valid_data = false;

        that.order_contact_data_modal = $.uiModal({
            html: that.modal,
            onOpen: function ($modal_wrapper) {
                UIInputMask.prototype.initEmailMask($modal_wrapper);
                UIInputMask.prototype.initEmailValidate($modal_wrapper);

                UIInputMask.prototype.initPhoneMask($modal_wrapper);
                var $modal_phone_input = $modal_wrapper.find(`.${that.class.input_phone}`);
                UIInput.prototype.setNotEmpty($modal_phone_input, !!$modal_phone_input.val());

                $modal_wrapper.find('.' + that.class.order_contact_data_form).on('submit', function (e) {
                    e.preventDefault();
                });
            },
            onButtonConfirmClick: function (modal) {
                if (that.__isValid(modal.$modal_body)) {
                    that.order_contact_data = {
                        email: $.trim(modal.$modal_body.find(`.${that.class.input_email}`).val()),
                        phone: $.trim(modal.$modal_body.find(`.${that.class.input_phone}`).val())
                    }
                    is_valid_data = true;
                } else {
                    return false;
                }
            },
            onClose: function () {
                if (typeof that.onClose === 'function') {
                    that.onClose(is_valid_data, that.order_contact_data);
                }
                that.order_contact_data_modal = null;
            }
        });
    };

    OrderContactDataForm.prototype.__isValid = function ($wrapper) {
        var that = this;

        return that.__validateEmail($wrapper) && that.__validatePhone($wrapper);
    };

    OrderContactDataForm.prototype.__validateEmail = function ($wrapper) {
        var that = this,
            $input = $wrapper.find(`.${that.class.input_email}`),
            result = $.trim($input.val()),
            required = $input.attr('required'),
            error_empty = $input.data('error-empty'),
            error_invalid = $input.data('error-invalid');

        UIInput.prototype.clearError($input);

        if (!result && required) {
            UIInput.prototype.setError($input, error_empty);
            return false;
        }

        if (result && !$.sa.validate.email(result)) {
            UIInput.prototype.setError($input, error_invalid);
            return false;
        }

        return true;
    };

    OrderContactDataForm.prototype.__validatePhone = function ($wrapper) {
        var that = this,
            $input = $wrapper.find(`.${that.class.input_phone}`),
            result = $.trim($input.val()),
            required = $input.attr('required'),
            error_invalid = $input.data('error-invalid'),
            error_empty = $input.data('error-empty');

        UIInput.prototype.clearError($input);

        if ((!result || result === '+7') && required) {
            UIInput.prototype.setError($input, error_empty);
            return false;
        }

        if (result && !UIInputMask.prototype.__validatePhone(result)) {
            UIInput.prototype.setError($input, error_invalid);
            return false;
        }

        return true;
    };

    return OrderContactDataForm;

})($);
